import 'css-chunksrc/client/scenes/resourceGroupEdition/groupEditionForm/resourcesList/resourceForm/styles.scss';export default {
  "resourceForm": "_resourceForm_1v6kn_1"
};